import { render, staticRenderFns } from "./commonSwitchTab.vue?vue&type=template&id=cec74946&scoped=true"
import script from "./commonSwitchTab.vue?vue&type=script&lang=js"
export * from "./commonSwitchTab.vue?vue&type=script&lang=js"
import style0 from "./commonSwitchTab.vue?vue&type=style&index=0&id=cec74946&prod&lang=css"
import style1 from "./commonSwitchTab.vue?vue&type=style&index=1&id=cec74946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec74946",
  null
  
)

export default component.exports